/**
 * Music — HTML5 Audio playback for background music.
 * Separate from the WebAudio synth pipeline (sound-manager.ts).
 */

import { getVolume, isMuted } from './sound-manager';

const MUSIC_VOLUME_SCALE = 0.3;

let audio: HTMLAudioElement | null = null;
let startCallback: (() => void) | null = null;

/** Register a callback for when music begins playing (e.g. show credit text). */
export function onMusicStart(cb: () => void): void {
  startCallback = cb;
}

/** Start looping background music from the given URL. */
export function startMusic(url: string): void {
  if (audio) return;
  audio = new Audio(url);
  audio.loop = true;
  audio.volume = isMuted() ? 0 : getVolume() * MUSIC_VOLUME_SCALE;
  audio.play().then(() => {
    if (startCallback) {
      startCallback();
      startCallback = null;
    }
  }).catch(err => {
    console.warn('[Music] Playback failed:', err);
  });
}

/** Stop music and reset. */
export function stopMusic(): void {
  if (!audio) return;
  audio.pause();
  audio.currentTime = 0;
  audio = null;
}

/** Sync music volume to current master volume. */
export function syncMusicVolume(): void {
  if (!audio) return;
  audio.volume = isMuted() ? 0 : getVolume() * MUSIC_VOLUME_SCALE;
}
